import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { CustomEventEnums } from "../../shared/utilities/enums/customEventEnums";
import { UtilityEnums } from "../../shared/utilities/enums/utillityEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { BasePagingSelectableCarousel, IBasePagingSelectableCarousel } from "./basePagingSelectableCarousel";
import { SelectableCarousel, ISelectableCarousel } from "./selectableCarousel";


export interface ISinglePagingSelectableCarousel extends IBasePagingSelectableCarousel {
    moveToPosition:()=>void;
}

export class SinglePagingSelectableCarousel extends BasePagingSelectableCarousel implements ISinglePagingSelectableCarousel {

    private readonly _moveCarouselToNextPosition;
    private readonly _moveCarouselToPrevPosition;
    private readonly _reinitialiseCarousel;

    public currentPage: number;

    constructor(public htmlElement: Element, carouselOrientation: UtilityEnums.ComponentOrientation, topLevelHtmlElement?: HTMLElement) {
        super(htmlElement, carouselOrientation, topLevelHtmlElement);

        this._moveCarouselToNextPosition = this.moveCarouselToNextPosition.bind(this);
        this._moveCarouselToPrevPosition = this.moveCarouselToPrevPosition.bind(this);
        this._reinitialiseCarousel = this.reinitialiseCarousel.bind(this);

        this.attachCarouselPageNextClickEventListener();
        this.attachCarouselPagePrevClickEventListener();
        this.attachViewportDimensionsChangedEventListener();

        this.setCarouselShowHideArrows();
    }

    //Carousel Events  
    attachCarouselPagePrevClickEventListener(): void {
        console.log('SinglePagingSelectableCarousel: attachCarouselPagePrevClickEventListener');
        this.carouselPrevElement.addEventListener('click', this._moveCarouselToPrevPosition);
    }

    removeCarouselPagePrevClickEventListener(): void {
        this.carouselPrevElement.removeEventListener('click', this._moveCarouselToPrevPosition);
    }

    attachCarouselPageNextClickEventListener(): void {
        console.log('SinglePagingSelectableCarousel: attachCarouselPageNextClickEventListener');
        this.carouselNextElement.addEventListener('click', this._moveCarouselToNextPosition);
    }

    removeCarouselPageNextClickEventListener(): void {
        this.carouselNextElement.removeEventListener('click', this._moveCarouselToNextPosition);
    }

    attachViewportDimensionsChangedEventListener(): void {
        console.log('SinglePagingSelectableCarousel: attachViewportDimensionsChangedEventListener');
        document.addEventListener(CustomEventEnums.ViewportDimensionsChangedEvent, this._reinitialiseCarousel);
    }

    removeViewportDimensionsChangedEventListener(): void {
        document.removeEventListener(CustomEventEnums.ViewportDimensionsChangedEvent, this._reinitialiseCarousel);
    }

    getCellsPerPage(): number {
        return 1;
    };

    setCurrentPage(): void {
        this.currentPage = this.carouselCurrentSelectedIndex + 1;
    }

    getInitialPage(): number {
        return this.carouselCurrentSelectedIndex + 1;
    }

    reinitialiseCarousel(): void {
        console.log('SinglePagingSelectableCarousel: reinitialiseCarousel');
        this.totalOccupiedCells = this.occupiedCellsElements.length;
        this.initialiseCarouselCurrentSelectedIndex();
        this.setCurrentPage();
        this.setCarouselShowHideArrows();
        this.moveToPosition();
    };

    moveCarouselToPrevPosition(): void {
        console.log('SinglePagingSelectableCarousel: moveCarouselToPrevPosition');
        if (this.hasPrevButton()) {
            this.setAllMediaTilesToInactive();
            this.carouselCurrentSelectedIndex -= 1;
            this.htmlElement.dispatchEvent(this.selectedCarouselCellSelectedEvent(this.carouselCurrentSelectedIndex));
        }
    }

    moveCarouselToNextPosition(): void {
        console.log('SinglePagingSelectableCarousel: moveCarouselToNextPosition');
        if (this.hasNextButton()) {
            this.setAllMediaTilesToInactive();
            this.carouselCurrentSelectedIndex += 1;
            this.htmlElement.dispatchEvent(this.selectedCarouselCellSelectedEvent(this.carouselCurrentSelectedIndex));
        }
    }

    moveToPosition(): void {
        console.log('SinglePagingSelectableCarousel: moveToPosition');
        this.moveCarouselToPosition(this.carouselCurrentSelectedIndex);
        this.setCurrentPage();
        this.setCarouselShowHideArrows();
    }

    updateCarouselCurrentSelectedIndex(index: number) {
        console.log('SinglePagingSelectableCarousel: updateCarouselCurrentSelectedIndex - index ' + index.toString());

        this.carouselPrevElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.PagingSelectableCarousel.Prev));
        this.carouselNextElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.PagingSelectableCarousel.Next));

        super.updateCarouselCurrentSelectedIndex(index);
        this.moveToPosition();
    }

    dispose(): void {
        super.dispose();
    }
}